import styled from "styled-components";

export const StyledForeground = styled.span`
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    height: ${({foreGroundHeight}) => foreGroundHeight ? foreGroundHeight : '33.5rem;'};
    width: 100%;
    background: linear-gradient(135deg,#0f82c5,#07bb9c);
`